<template>
  <div :class="{ 'month-wrap': isMobile }" ref="wrap">
    <div id="homeMonthChart" class="month-chart" :style="chartBoxStyle"></div>
  </div>
</template>
<script>
export default {
  props: {
    yDataArrs: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      xDataArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    }
  },
  computed: {
    chartBoxStyle () {
      if (!this.isMobile) {
        return { width: '100%', height: '300px', padding: 0, margin: 0 }
      }
      return { width: '100%', height: 'clamp(280px, 65vw, 360px)', padding: 0, margin: 0 }
    }
  },
  mounted () {
    console.log(this.yDataArrs, '这是按月份的数据')
    this.drawLine()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    const el = document.getElementById('homeMonthChart')
    if (el) {
      const c = this.$echarts.getInstanceByDom(el)
      if (c) c.dispose()
    }
  },
  watch: {
    yDataArrs: {
      handler () {
        this.drawLine()
      },
      deep: true
    },
    isMobile () {
      this.$nextTick(() => this.drawLine())
    }
  },
  methods: {
    onResize () {
      const el = document.getElementById('homeMonthChart')
      if (!el) return
      const chart = this.$echarts.getInstanceByDom(el)
      if (chart) chart.resize()
    },
    computeBarLayoutMobile () {
  const el = document.getElementById('homeMonthChart')
  const cw = (el && el.clientWidth) || (this.$refs.wrap && this.$refs.wrap.clientWidth) || 320
  const n = Math.max(this.xDataArr.length, 1)
  
  // 1. 缩小左右边距
  const gridLR = 0.05 
  
  const plotW = cw * (1 - gridLR * 2)
  const slot = plotW / n
  
  // 2. 放大柱宽比例和上限 (由 max 16 改为 max 24)
  let barPx = Math.round(slot * 0.5) // 柱体占据槽宽的比例从 0.45 提高到 0.5
  barPx = Math.max(8, Math.min(barPx, 24)) // 最大允许 24px 宽
  
  return {
    barPx,
    bottomPct: '20%',
    labelFont: 11,
    gridLR
  }
},
    drawLineDesktop () {
      const myChart = this.$echarts.init(document.getElementById('homeMonthChart'))
      myChart.setOption({
        title: { text: '' },
        tooltip: {
          trigger: 'axis',
          formatter: (arg) => {
            return arg[0].name + this.$t('homeMonth.月的数据是') + '：' + arg[0].data
          }
        },
        grid: {
          top: '10%',
          right: '5%',
          bottom: '30%'
        },
        xAxis: {
          data: this.xDataArr
        },
        yAxis: {
          type: 'value',
          axisLine: {}
        },
        series: [{
          name: this.$t('homeMonth.用水'),
          type: 'bar',
          data: this.yDataArrs,
          itemStyle: {
            barWidth: 10,
            color: '#744DFE',
            barBorderRadius: 20
          },
          barWidth: 10
        }]
      })
    },
    drawLineMobile () {
      const el = document.getElementById('homeMonthChart')
      if (!el) return
      let chart = this.$echarts.getInstanceByDom(el)
      if (!chart) {
        chart = this.$echarts.init(el)
      }
      const { barPx, bottomPct, labelFont, gridLR } = this.computeBarLayoutMobile()
      chart.setOption({
        title: { text: '' },
        tooltip: {
          trigger: 'axis',
          formatter: (arg) => {
            if (!arg || !arg[0]) return ''
            return arg[0].name + this.$t('homeMonth.月的数据是') + '：' + arg[0].data
          }
        },
        grid: {
          top: '12%',
          left: `${gridLR * 100}%`,
          right: `${gridLR * 100}%`,
          bottom: bottomPct,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xDataArr,
          axisLabel: { fontSize: labelFont }
        },
        yAxis: {
          type: 'value',
          axisLabel: { fontSize: labelFont }
        },
        series: [{
          name: this.$t('homeMonth.用水'),
          type: 'bar',
          data: this.yDataArrs,
          barWidth: barPx,
          barMaxWidth: barPx + 4,
          itemStyle: {
            color: '#744DFE',
            barBorderRadius: 10
          }
        }]
      }, true)
      chart.resize()
    },
    drawLine () {
      this.$nextTick(() => {
        const el = document.getElementById('homeMonthChart')
        if (!el) return
        const existing = this.$echarts.getInstanceByDom(el)
        if (existing) {
          existing.dispose()
        }
        if (this.isMobile) {
          this.drawLineMobile()
        } else {
          this.drawLineDesktop()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.month-wrap {
  width: 100%;
  min-width: 0;
}
.month-chart {
  min-height: 0;
}
.month-wrap .month-chart {
  min-height: 220px;
}
</style>
